// Refactor 02/2026 — extrahiert aus AppointmentsPage.js (rote Linie für
// "jetzt" in der Tages-Ansicht, inkl. Time-Badge).
import React from 'react';

export const CurrentTimeIndicator = ({
  currentDate,
  calendarStartHour,
  calendarEndHour,
  calendarStartMinutes,
  slotHeight,
}) => {
  if (currentDate.toDateString() !== new Date().toDateString()) return null;

  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  if (currentHour < calendarStartHour || currentHour >= calendarEndHour) {
    return null;
  }

  const currentMinutesFromMidnight = currentHour * 60 + currentMinute;
  const minutesFromCalendarStart =
    currentMinutesFromMidnight - calendarStartMinutes;

  // Header height: p-3 = 12px*2 padding + line-height ~= 60px total
  const headerHeight = 60;
  const topPosition =
    headerHeight + (minutesFromCalendarStart / 30) * slotHeight;
  const currentTimeStr = `${currentHour.toString().padStart(2, '0')}:${currentMinute
    .toString()
    .padStart(2, '0')}`;

  return (
    <div
      data-testid="current-time-indicator"
      style={{
        position: 'absolute',
        left: '0',
        right: '0',
        top: `${topPosition}px`,
        zIndex: 5, // Niedriger z-index damit Dialoge darüber sind
        pointerEvents: 'none',
        width: '100%',
      }}
    >
      {/* Time Badge */}
      <div
        style={{
          position: 'absolute',
          left: '10px',
          top: '-10px',
          backgroundColor: '#EF4444',
          color: 'white',
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '11px',
          fontWeight: 'bold',
          zIndex: 6,
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        }}
      >
        🕐 {currentTimeStr}
      </div>
      {/* Red Line */}
      <div
        style={{
          width: '100%',
          height: '3px',
          backgroundColor: '#EF4444',
          boxShadow: '0 1px 3px rgba(239,68,68,0.4)',
          zIndex: 5,
        }}
      />
    </div>
  );
};

export default CurrentTimeIndicator;
